import React from 'react';
import PropTypes from 'prop-types';
import { IconButton, Typography, Button } from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';

import { useStyles } from '../purchaseTransactionsDialog.styles';

function PickStep ({
    titleId,
    onClose,
    used,
    total,
    remaining,
    usedPercent,
    packSize,
    pricePerPack,
    packs,
    quantity,
    amount,
    setPacks,
    incPacks,
    decPacks,
    goToPayment,
}) {
    const classes = useStyles();

    return (
        <React.Fragment>
            <div className={classes.header}>
                <div>
                    <Typography id={titleId} className={classes.title}>
                        Purchase Transactions
                    </Typography>
                    <Typography className={classes.subtitle}>
                        Add a one-time transaction top-up to your account
                    </Typography>
                </div>
                <IconButton
                    aria-label="Close"
                    className={classes.closeButton}
                    onClick={onClose}
                    size="small"
                >
                    <CloseIcon fontSize="small" />
                </IconButton>
            </div>

            <div className={classes.body}>
                <div className={classes.balanceBox}>
                    <Typography className={classes.balanceLabel}>
                        Current balance
                    </Typography>
                    <div className={classes.balanceRow}>
                        <span className={classes.balanceUsed}>
                            {`${used.toLocaleString()} of ${total.toLocaleString()} used this period`}
                        </span>
                        <span className={classes.balanceRemaining}>
                            {`${remaining.toLocaleString()} remaining`}
                        </span>
                    </div>
                    <div className={classes.barTrack}>
                        <div
                            className={classes.barFill}
                            style={{ width: `${usedPercent}%` }}
                        />
                    </div>
                    <Typography className={classes.balanceNote}>
                        Purchased transactions do not expire until end of billing period
                    </Typography>
                </div>

                <Typography className={classes.sectionLabel}>
                    Add transactions
                </Typography>
                <div className={classes.bundleCard}>
                    <div className={classes.bundleRow}>
                        <div>
                            <Typography className={classes.bundleName}>
                                Extra transactions
                            </Typography>
                            <Typography className={classes.bundleSub}>
                                {`$${pricePerPack} per ${packSize.toLocaleString()} transactions`}
                            </Typography>
                        </div>
                        <div className={classes.stepper}>
                            <button
                                type="button"
                                aria-label="Decrease quantity"
                                className={classes.stepperBtn}
                                onClick={decPacks}
                                disabled={packs <= 1}
                            >
                                −
                            </button>
                            <input
                                type="number"
                                min="1"
                                aria-label="Number of transaction packs"
                                className={classes.stepperInput}
                                value={packs}
                                onChange={(e) => setPacks(e.target.value)}
                            />
                            <button
                                type="button"
                                aria-label="Increase quantity"
                                className={classes.stepperBtn}
                                onClick={incPacks}
                            >
                                +
                            </button>
                        </div>
                    </div>
                    <div className={classes.bundleTotalRow}>
                        <span className={classes.bundleTxns}>
                            <strong className={classes.bundleTxnsStrong}>
                                {quantity.toLocaleString()}
                            </strong>
                            {' transactions'}
                        </span>
                        <span className={classes.bundlePrice}>
                            {`$${amount.toLocaleString()}`}
                        </span>
                    </div>
                </div>

                <div className={classes.orderSummary}>
                    <Typography className={classes.summaryLabel}>
                        Order summary
                    </Typography>
                    <div className={classes.summaryRow}>
                        <span className={classes.summaryItem}>
                            {`${quantity.toLocaleString()} additional transactions`}
                        </span>
                        <span className={classes.summaryValue}>
                            {`$${amount.toLocaleString()}.00`}
                        </span>
                    </div>
                    <div className={classes.summaryTotalRow}>
                        <span className={classes.summaryTotalLabel}>
                            Total due today
                        </span>
                        <span className={classes.summaryTotalValue}>
                            {`$${amount.toLocaleString()}.00`}
                        </span>
                    </div>
                    <Typography className={classes.summaryNote}>
                        Transactions available immediately
                    </Typography>
                </div>

                <div className={classes.footer}>
                    <Button className={classes.secondaryBtn} onClick={onClose}>
                        Cancel
                    </Button>
                    <Button className={classes.primaryBtn} onClick={goToPayment}>
                        Continue to payment
                    </Button>
                </div>
            </div>
        </React.Fragment>
    );
}

PickStep.propTypes = {
    titleId: PropTypes.string.isRequired,
    onClose: PropTypes.func.isRequired,
    used: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
    remaining: PropTypes.number.isRequired,
    usedPercent: PropTypes.number.isRequired,
    packSize: PropTypes.number.isRequired,
    pricePerPack: PropTypes.number.isRequired,
    packs: PropTypes.number.isRequired,
    quantity: PropTypes.number.isRequired,
    amount: PropTypes.number.isRequired,
    setPacks: PropTypes.func.isRequired,
    incPacks: PropTypes.func.isRequired,
    decPacks: PropTypes.func.isRequired,
    goToPayment: PropTypes.func.isRequired,
};

export default PickStep;
